
import publicUrl from '@/assets/js/interface'

const state = {
  classesList: [],
  classActiveIndex: -1,
  studentsList: [],
  groupsList: [],
  notInGroupStudents: [],
  stuClassInfo: {},
}

const getters = {
  classActive(state) {
    return state.classesList[state.classActiveIndex] || {}
  },
  studentsDict(state) {
    let result = {}
    state.studentsList.forEach(v => {
      v && (result[v.id] = v)
    })
    return result
  }
}

const mutations = {
  // 设置班级列表
  setClassesList(state, params) {
    state.classesList = params || []
  },
  // 设置小组列表
  setGroupsList(state, params) {
    state.groupsList = params || []
  },
  // 设置学生列表
  setStudentsList(state, params) {
    state.studentsList = params || []
  },
  // 设置当前班级序号
  setClassActiveIndex(state, params) {
    state.classActiveIndex = params
  },
  // 没分组的学生列表
  setNotInGroupStudents(state, params) {
    state.notInGroupStudents = params || []
  },
  // 学生班级信息
  setStuClassInfo(state, params) {
    state.stuClassInfo = params || {}
  },
}

const actions = {

  getStudentsList({ commit, getters }, { vm }) {
    commit('setStudentsList', [])
    return vm.$ajax.get(publicUrl.classStudentsList, {
      params: { classId: getters.classActive.id }
    }).then(res => {
      if (res.data.code === 0) {
        commit('setStudentsList', res.data.data || [])
      } else {
        vm.$message.error(res.data.message)
      }
    }).catch(err => {
      vm.$ajaxError(err)
    })
  },
  getGroupsList({ commit, getters }, { vm }) {
    commit('setGroupsList', [])
    return vm.$ajax.get(publicUrl.classGroupList, {
      params: { classId: getters.classActive.id }
    }).then(res => {
      if (res.data.code === 0) {
        let _data = res.data.data || {}
        commit('setGroupsList', _data.groups || [])
        commit('setNotInGroupStudents', _data.notInGroupStudents || [])
      } else {
        vm.$message.error(res.data.message)
      }
    }).catch(err => {
      vm.$ajaxError(err)
    })
  },
  getStuClassInfo({ commit }, { vm }) {
    commit('setStuClassInfo', {})
    commit('setGroupsList', [])
    commit('setStudentsList', [])
    commit('setClassesList', [])
    commit('setClassActiveIndex', -1)
    return vm.$ajax.get(publicUrl.myClass).then(res => {
      if (res.data.code === 0) {
        let _data = res.data.data || {}
        commit('setStuClassInfo', _data)
        commit('setGroupsList', _data.groups || [])
        commit('setStudentsList', _data.students || [])
        commit('setClassesList', [{
          id: _data.id,
          gradeCode: _data.gradeCode,
          gradeName: _data.gradeName,
          name: _data.name,
          studentNum: _data.studentNum,
        }])
        commit('setClassActiveIndex', 0)
      } else {
        vm.$message.error(res.data.message)
      }
    }).catch(err => {
      vm.$ajaxError(err)
    })
  },
  getTeachingClasses({ commit }, { vm }) {
    commit('setClassesList', [])
    return vm.$ajax.get(publicUrl.classList).then(res => {
      if (res.data.code === 0) {
        let classesList = res.data.data || []
        commit('setClassesList', classesList)
      } else {
        vm.$message.error(res.data.message)
      }
    }).catch(err => {
      vm.$ajaxError(err)
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
